// src/pages/auth/magic.jsx
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ENDPOINT = "https://api.sobevenda.com.br/api-proxy/affiliate/login-magic";

export default function Magic() {
  const navigate = useNavigate();
  const location = useLocation();
  const [msg, setMsg] = useState("Validando link...");

  useEffect(() => {
    const run = async () => {
      try {
        const token = new URLSearchParams(location.search).get("token");
        console.log("[MAGIC] token param =", token);

        if (!token) {
          setMsg("Link inválido ou expirado.");
          return;
        }

        // 1) Tenta POST JSON
        let res = await fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        console.log("[MAGIC] POST status =", res.status);

        // 2) Se falhar, tenta GET com querystring (fallback)
        if (!res.ok) {
          const fallbackUrl = `${ENDPOINT}?token=${encodeURIComponent(token)}`;
          console.log("[MAGIC] POST falhou, tentando GET:", fallbackUrl);
          res = await fetch(fallbackUrl, { method: "GET" });
          console.log("[MAGIC] GET status =", res.status);
        }

        if (!res.ok) {
          // Mostra corpo para debug rápido (vai aparecer no console)
          const txt = await res.text();
          console.error("[MAGIC] Resposta não OK:", res.status, txt);
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json().catch(() => ({}));
        console.log("[MAGIC] payload =", data);

        // Xano pode devolver { authToken: "jwt" } ou { authToken: { token: "jwt" } }
        const jwt =
          data?.authToken?.token ??
          data?.authToken ??
          data?.token ??
          null;

        if (!jwt) {
          console.error("[MAGIC] JWT ausente no payload");
          throw new Error("Token ausente");
        }

        // Salva (igual seu PrivateRoute espera)
        localStorage.setItem("sobevenda_token", jwt);
        // Cookie opcional (24h)
        document.cookie = `sv_auth=${jwt}; Path=/; Max-Age=86400; Secure; SameSite=Lax`;

        setMsg("Acesso liberado. Redirecionando...");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("[MAGIC] Erro:", e);
        setMsg("Link inválido ou expirado.");
      }
    };

    run();
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 text-gray-200">
      <p>{msg}</p>
    </div>
  );
}
